if(typeof __WEBPACK_EXTERNAL_MODULE__162__ === 'undefined') { var e = new Error("Cannot find module 'pandoc-wasm'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__162__;